import { ReactNode } from 'react';
import {
  ResponsiveTableReactContext,
  useResponsiveTableContext,
} from './ResponsiveTableContext';

export const TableContextReproducer = ({
  children,
  tableName,
}: {
  children: ReactNode;
  tableName: string;
}) => {
  const context = useResponsiveTableContext(tableName);

  return (
    <ResponsiveTableReactContext.Provider value={context}>
      {children}
    </ResponsiveTableReactContext.Provider>
  );
};
